export default {
    R_AUTH: 'authenticate',


    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
    BAD_MSG: 'bad_message',
    AUTH_FAIL: 'authentication_fail',
    AUTH_OK: 'authentication_ok',
    EXR_JOIN_OK: 'exercise_join_ok',
    EXR_JOIN_FAIL: 'exercise_join_fail',
    EXR_STAT_UPD: 'exercise_status_update',
    TEXT_MSG: 'text_message',
    USR_LEFT: 'user_left',
    USR_JOINED: 'user_joined',
    USR_LOC_UPD: 'user_location_update',
    USR_MOVE: 'user_move',
    USR_STAT_UPD: 'user_status_update',
    USR_RENAME: 'user_rename',
    USR_READY: 'user_ready',
    SET_VAR: 'set_var',
    PLAY_START: 'play_start'
}
